import { jsxs, jsx } from "react/jsx-runtime";
import { PRIMARY_KEY_NAME } from "../bindingTypes.js";
import { Component } from "./Component.js";
import { EntityList } from "./EntityList.js";
import { Field } from "./Field.js";
import { TreeNodeEnvironmentFactory } from "../dao/TreeNodeEnvironmentFactory.js";
import { useEntityList } from "../accessorPropagation/useEntityList.js";
import { MarkerFactory } from "../queryLanguage/MarkerFactory.js";
const HasMany = Component(
  (props) => {
    const entityList = useEntityList(props);
    return /* @__PURE__ */ jsx(EntityList, { ...props, accessor: entityList });
  },
  {
    generateEnvironment: (props, oldEnvironment) => {
      const environment = oldEnvironment.withVariables(props.variables);
      return TreeNodeEnvironmentFactory.createEnvironmentForEntityList(environment, props);
    },
    staticRender: (props) => /* @__PURE__ */ jsxs(EntityList, { ...props, accessor: void 0, children: [
      /* @__PURE__ */ jsx(Field, { field: PRIMARY_KEY_NAME }),
      props.children
    ] }),
    generateBranchMarker: (props, fields, environment) => MarkerFactory.createRelativeEntityListFields(props, environment, fields)
  },
  "HasMany"
);
export {
  HasMany
};
//# sourceMappingURL=HasMany.js.map
